import { DateTime } from 'luxon';

/**
 * Parse the `HH:mm` value of a native `<input type="time">`.
 *
 * The element hands us an empty string whenever it has no value — the user
 * cleared it, or the field renders blank because the entry is all-day — and
 * arbitrary text when a keyboard user types into it. With
 * `Settings.throwOnInvalid` enabled (see src/index.tsx), `DateTime.fromFormat`
 * *throws* on unparsable input instead of returning an invalid DateTime, so an
 * `isValid` check on the result is unreachable and every blur handler that
 * parsed the raw value crashed the moment the field was emptied
 * (Sentry WEB-CLIENT-1K9).
 *
 * Returns `null` for anything unparsable so callers handle "no usable time"
 * with a single falsy check.
 */
export const parseTime = (value: string): DateTime | null => {
  try {
    const parsed = DateTime.fromFormat(value, 'HH:mm');
    return parsed.isValid ? parsed : null;
  } catch {
    return null;
  }
};
